// extracted by mini-css-extract-plugin
export var active = "_ff-1";
export var circle = "_ff-0";
export var completed = "_ff-2";
export var connector = "_ff-4";
export var connectorCompleted = "_ff-7";
export var connectorSpacer = "_ff-5";
export var iconStrokeOverride = "_ff-8";
export var labelContainer = "_ff-6";
export var pending = "_ff-3";